import { useMutation, useQuery } from "@tanstack/react-query";
import { createReview, deleteReview, getAdminReviewDetail, getAdminReviewList, getAdminReviewResultDetail, getAdminReviewResultList, getAdminReviewReviewee, modifyReview, modifyReviewStatus } from "./service";

/**
 * admin/Review
 */

export const useAdminReviewList = (pageNum, count) =>
    useQuery({
        queryKey: ["adminreviewlist", pageNum, count],
        queryFn: () => getAdminReviewList(pageNum, count),
    });

export const useAdminReviewDetail = (idx) =>
    useQuery({
        queryKey: ["adminreviewdetail", idx],
        queryFn: () => getAdminReviewDetail(idx),
    });

export const useAdminReviewReviewee = (idx) =>
    useQuery({
        queryKey: ["adminreviewreviewee", idx],
        queryFn: () => getAdminReviewReviewee(idx),
    });

export const useModifyReviewStatus = () => {
    return useMutation({
        mutationKey: ["modifyreviewstatus"],
        mutationFn: async (data) => {
            return await modifyReviewStatus(data);
        },
        onSuccess: (data) => {
            console.log("onSuccess", data);
        },
        onError: (error) => {
            console.log("onError", error);
        },
    });
};

export const useCreateReview = () => {
    return useMutation({
        mutationKey: ["adminreviewcreate"],
        mutationFn: async (data) => {
            return await createReview(data);
        },
        onSuccess: (data) => {
            console.log("onSuccess", data);
        },
        onError: (error) => {
            console.log("onError", error);
        },
    });
};

export const useModifyReview = () => {
    return useMutation({
        mutationKey: ["adminreviewmodify"],
        mutationFn: async (data) => {
            return await modifyReview(data);
        },
        onSuccess: (data) => {
            console.log("onSuccess", data);
        },
        onError: (error) => {
            console.log("onError", error);
        },
    });
};

export const useDeleteReview = () => {
    return useMutation({
        mutationKey: ["adminreviewdelete"],
        mutationFn: async (idx) => {
            return await deleteReview(idx);
        },
        onSuccess: (data) => {
            console.log("onSuccess", data);
        },
        onError: (error) => {
            console.log("onError", error);
        },
    });
};

export const useAdminReviewResultList = (pageNum, count) =>
    useQuery({
        queryKey: ["reviewresultlist", pageNum, count],
        queryFn: () => getAdminReviewResultList(pageNum, count),
    });

export const useAdminReviewResultDetail = (reviewIdx, revieweeIdx) =>
    useQuery({
        queryKey: ["reviewresultdetail", reviewIdx, revieweeIdx],
        queryFn: () => getAdminReviewResultDetail(reviewIdx, revieweeIdx),
        enabled: !!revieweeIdx
    });
